import {
  LOAD_SITES_FAIL,
  LOAD_SITES_SUCCESS,
  DELETE_SITES_FAIL,
  DELETE_SITES_START,
  DELETE_SITES_SUCCESS,
  EXPORT_SITES_START,
  EXPORT_SITES_FAIL,
  EXPORT_SITES_FINISHED,
  GEOCODE_SITES_FAIL,
  GEOCODE_SITES_START,
  GEOCODE_SITES_SUCCESS,
  PROCESSING_SITES_ONTO,
  SITE_LIST_CANCEL_ACTION,
  SITE_LIST_REFRESH,
  IS_FORM_DIRTY,
  SHOW_CHICKEN_EXIT,
} from 'actions/sites';
import { getListPageSuccessNewData } from 'reducers/utils';
import find from 'lodash/find';

const defaultState = {
  data: [],
  processingSite: null,
  error: false,
  exporting: false,
  loading: true,
  processing: false,
  shouldCancel: false,
  total: 0,
  operation: null,
  isFormDirty: false,
  showChickenExit: false,
};

export default function siteListPage(state = defaultState, action) {
  switch (action.type) {
    case LOAD_SITES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case LOAD_SITES_SUCCESS: {
      const { data, links, total } = action.payload;
      return {
        ...state,
        data: getListPageSuccessNewData(state, data, links),
        loading: false,
        total,
      };
    }
    case EXPORT_SITES_START: {
      return {
        ...state,
        exporting: true,
      };
    }
    case EXPORT_SITES_FAIL:
    case EXPORT_SITES_FINISHED: {
      return {
        ...state,
        exporting: false,
      };
    }
    case DELETE_SITES_START:
    case GEOCODE_SITES_START: {
      return {
        ...state,
        processing: true,
        shouldCancel: false,
      };
    }
    case DELETE_SITES_SUCCESS:
    case GEOCODE_SITES_SUCCESS: {
      return {
        ...state,
        processing: false,
        shouldCancel: false,
      };
    }
    case SITE_LIST_REFRESH: {
      return {
        ...state,
        data: [], // Require reload
        loading: true,
        shouldCancel: false,
      };
    }
    case DELETE_SITES_FAIL:
    case GEOCODE_SITES_FAIL: {
      return {
        ...state,
        processing: false,
        shouldCancel: false,
      };
    }
    case SITE_LIST_CANCEL_ACTION: {
      return {
        ...state,
        shouldCancel: true,
        processing: false,
      };
    }
    case PROCESSING_SITES_ONTO: {
      const site = find(state.data, { id: action.payload });
      return {
        ...state,
        processingSite: site || null,
      };
    }
    case IS_FORM_DIRTY: {
      return {
        ...state,
        isFormDirty: action.payload,
      };
    }
    case SHOW_CHICKEN_EXIT: {
      return {
        ...state,
        showChickenExit: action.payload,
      };
    }
    default:
      return state;
  }
}
